// extracted by mini-css-extract-plugin
export default {"form":"paymentHidden3dsPopup-module__form__6sRfg"};